"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OurBrands = exports.loadTheme = exports.mixins = void 0;
const styles_1 = require("@material-ui/core/styles");
const createMixins_1 = __importDefault(require("@material-ui/core/styles/createMixins"));
const overridesUpgradeMixer_1 = require("./themeParts/overridesUpgradeMixer");
const fonts_1 = require("./themeParts/fonts");
const colors_1 = require("./themeParts/colors");
Object.defineProperty(exports, "OurBrands", { enumerable: true, get: function () { return colors_1.OurBrands; } });
const buildColorsByBrand_1 = require("./themeParts/buildColorsByBrand");
const shadows_1 = require("./themeParts/shadows");
// MUI5 Theme Builder Imports
const styles_2 = require("@mui/material/styles");
// MUI v4 theme creator can still create spacing and breakpoints to are forwards compatible with the v5
const { breakpoints: customBreakpoint, spacing } = (0, styles_1.createTheme)();
exports.mixins = (0, createMixins_1.default)(customBreakpoint, spacing, {
    limitLines: (number = 3) => {
        return {
            display: '-webkit-box',
            '-webkit-line-clamp': `${number}`,
            '-webkit-box-orient': 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        };
    },
    noList: {
        listStyle: 'none',
        padding: 0,
        margin: 0,
    },
});
const loadTheme = (brandStyles = colors_1.OurBrands.SigmaAldrich, makeNotoPrimaryFont = false) => {
    const generatedColorData = (0, buildColorsByBrand_1.buildColorsByBrand)(brandStyles);
    const fontFamilySet = makeNotoPrimaryFont ? fonts_1.notoFontFamily : fonts_1.latoFontFamily;
    const Colors = generatedColorData.colors;
    const AccentColors = generatedColorData.accentColors;
    const fontBases = (0, fonts_1.buildBaseFontStyles)(makeNotoPrimaryFont, brandStyles);
    const muiV4ThemeConfig = {
        palette: {
            action: {
                disabledBackground: Colors.Grey500,
                focus: Colors.PrimaryMain,
            },
            background: {
                default: Colors.White,
                grey: Colors.BackgroundGray,
                highlight: Colors.Highlight,
                blue: Colors.BackgroundBlue,
            },
            divider: Colors.Divider,
            error: {
                main: Colors.ErrorMain,
                light: Colors.ErrorLight,
            },
            grey: {
                '50': Colors.Grey50,
                '100': Colors.Grey100,
                '200': Colors.Grey200,
                '300': Colors.Grey300,
                '400': Colors.Grey400,
                '500': Colors.Grey500,
                '600': Colors.Grey600,
                '700': Colors.Grey700,
                '800': Colors.Grey800,
                '900': Colors.Grey900,
            },
            primary: {
                light: Colors.PrimaryLight,
                main: Colors.PrimaryMain,
                dark: Colors.PrimaryDark,
            },
            rich: {
                purple: AccentColors.RichPurple,
                blue: AccentColors.RichBlue,
                green: AccentColors.RichGreen,
                red: AccentColors.RichRed,
            },
            secondary: {
                light: Colors.SecondaryLight,
                main: Colors.SecondaryMain,
                dark: Colors.SecondaryDark,
            },
            sensitive: {
                pink: AccentColors.SensitivePink,
                blue: AccentColors.SensitiveBlue,
                green: AccentColors.SensitiveGreen,
                yellow: AccentColors.SensitiveYellow,
            },
            success: {
                main: Colors.SuccessMain,
                dark: Colors.SuccessDark,
                light: Colors.SuccessLight,
            },
            text: {
                primary: Colors.TextPrimary,
            },
            vibrant: {
                magenta: AccentColors.VibrantMagenta,
                cyan: AccentColors.VibrantCyan,
                green: AccentColors.VibrantGreen,
                yellow: AccentColors.VibrantYellow,
            },
            warning: {
                main: Colors.WarningMain,
                dark: Colors.WarningDark,
                light: Colors.WarningLight,
            },
            brand: {
                dark: Colors.BrandDark,
                light: Colors.BrandLight,
                main: Colors.BrandMain,
            },
            orange: Colors.Orange,
            tonalOffset: 0.1,
        },
        typography: {
            fontFamily: fontFamilySet,
            fontWeightRegular: makeNotoPrimaryFont
                ? fonts_1.NotoFontWeights.Regular
                : fonts_1.FontWeights.Regular,
            fontWeightMedium: makeNotoPrimaryFont
                ? fonts_1.NotoFontWeights.SemiBold
                : fonts_1.FontWeights.Bold,
            fontWeightBold: makeNotoPrimaryFont
                ? fonts_1.NotoFontWeights.Bold
                : fonts_1.FontWeights.Black,
            h1: fontBases.h1,
            h2: fontBases.h2,
            h3: fontBases.h3,
            h4: fontBases.h4,
            body1: fontBases.body1,
            body2: fontBases.body2,
            caption: fontBases.caption,
        },
        shape: {
            borderRadius: 5,
        },
        spacing: 4,
        shadows: shadows_1.shadowsArray,
        props: {
            MuiButtonBase: {
                disableRipple: true,
            },
            MuiButton: {
                disableRipple: true,
            },
            MuiCheckbox: {
                disableRipple: true,
            },
            MuiLink: {
                underline: 'none',
            },
            MuiTab: {
                disableRipple: true,
            },
            MuiIconButton: {
                disableRipple: true,
            },
        },
        mixins: exports.mixins,
    };
    const muiV5ThemeConfig = {
        palette: {
            action: {
                disabledBackground: Colors.Grey500,
                focus: Colors.PrimaryMain,
            },
            background: {
                default: Colors.White,
                grey: Colors.BackgroundGray,
                highlight: Colors.Highlight,
                blue: Colors.BackgroundBlue,
            },
            divider: Colors.Divider,
            error: {
                main: Colors.ErrorMain,
            },
            grey: {
                '50': Colors.Grey50,
                '100': Colors.Grey100,
                '200': Colors.Grey200,
                '300': Colors.Grey300,
                '400': Colors.Grey400,
                '500': Colors.Grey500,
                '600': Colors.Grey600,
                '700': Colors.Grey700,
                '800': Colors.Grey800,
                '900': Colors.Grey900,
            },
            primary: {
                light: Colors.PrimaryLight,
                main: Colors.PrimaryMain,
                dark: Colors.PrimaryDark,
            },
            rich: {
                purple: AccentColors.RichPurple,
                blue: AccentColors.RichBlue,
                green: AccentColors.RichGreen,
                red: AccentColors.RichRed,
            },
            secondary: {
                light: Colors.SecondaryLight,
                main: Colors.SecondaryMain,
                dark: Colors.SecondaryDark,
            },
            sensitive: {
                pink: AccentColors.SensitivePink,
                blue: AccentColors.SensitiveBlue,
                green: AccentColors.SensitiveGreen,
                yellow: AccentColors.SensitiveYellow,
            },
            success: {
                main: Colors.SuccessMain,
                dark: Colors.SuccessDark,
            },
            text: {
                primary: Colors.TextPrimary,
            },
            vibrant: {
                magenta: AccentColors.VibrantMagenta,
                cyan: AccentColors.VibrantCyan,
                green: AccentColors.VibrantGreen,
                yellow: AccentColors.VibrantYellow,
            },
            warning: {
                main: Colors.WarningMain,
                dark: Colors.WarningDark,
            },
            brand: {
                dark: Colors.BrandDark,
                light: Colors.BrandLight,
                main: Colors.BrandMain,
            },
            orange: Colors.Orange,
            tonalOffset: 0.1,
        },
        typography: {
            fontFamily: fontFamilySet,
            fontWeightRegular: makeNotoPrimaryFont
                ? fonts_1.NotoFontWeights.Regular
                : fonts_1.FontWeights.Regular,
            fontWeightMedium: makeNotoPrimaryFont
                ? fonts_1.NotoFontWeights.SemiBold
                : fonts_1.FontWeights.Bold,
            fontWeightBold: makeNotoPrimaryFont
                ? fonts_1.NotoFontWeights.Bold
                : fonts_1.FontWeights.Black,
            h1: fontBases.h1,
            h2: fontBases.h2,
            h3: fontBases.h3,
            h4: fontBases.h4,
            body1: fontBases.body1,
            body2: fontBases.body2,
            caption: fontBases.caption,
        },
        shape: {
            borderRadius: 5,
        },
        spacing: 4,
        shadows: shadows_1.shadowsArray,
        mixins: exports.mixins,
    };
    const overridesAndComponents = (0, overridesUpgradeMixer_1.buildMuiOverridesAndComponents)(brandStyles, makeNotoPrimaryFont);
    // Create all of the MUI v4 Theme Options and then pass it to a Mui4 theme creator.
    const muiV4Theme = muiV4ThemeConfig;
    muiV4Theme.overrides = overridesAndComponents.muiV4;
    const builtMui4Theme = (0, styles_1.createTheme)(muiV4Theme);
    // Create all of the MUI v5 Theme Options and then pass it to a Mui4 theme creator.
    const muiV5Theme = muiV5ThemeConfig;
    muiV5Theme.components = overridesAndComponents.muiV5;
    const builtMui5Theme = (0, styles_2.createTheme)(muiV5Theme);
    return {
        mui4Theme: builtMui4Theme,
        mui5Theme: builtMui5Theme,
    };
};
exports.loadTheme = loadTheme;
//# sourceMappingURL=index.js.map